export enum ApprovalStatus {
    None = -1,
    Pending = 0,
    Approved = 1,
    Declined = 2,
    Limited = 3,
    BlockedByAuctioneer = 4,
    Suspended = 5,
}
